import React from 'react';

import sy from '~/styles';
import {Text} from '~/components/controls';
import PropTypes from 'prop-types';

export const getHighlightPosition = (text, highlight) =>
  text.toLowerCase().indexOf(highlight.toLowerCase());

const HighlightText = ({text, highlight, highlightedStyle = sy.mediumBold}) => {
  const position = getHighlightPosition(text, highlight);

  return (
    <>
      {position === -1 ? (
        <Text>{text}</Text>
      ) : (
        <>
          {position > 0 && <Text>{text.substring(0, position)}</Text>}
          <Text style={highlightedStyle}>
            {text.substring(position, position + highlight.length)}
          </Text>
          {position + highlight.length < text.length && (
            <Text>{text.substring(position + highlight.length)}</Text>
          )}
        </>
      )}
    </>
  );
};
HighlightText.propTypes = {
  text: PropTypes.any,
  highlight: PropTypes.any,
};

export default HighlightText;
